import { jsx } from 'react/jsx-runtime';
import { styled, Box, shape, palette } from '@hub-la/design-system';

let _ = t => t,
  _t,
  _t2;
const MainBar = styled(Box)(_t || (_t = _`
  border-radius: ${0};
  background-color: ${0};
  width: 100%;
  height: 4px;
  overflow: hidden;
`), shape('extraSmall'), palette('surfaceAt3'));
const DynamicBar = styled(Box)(_t2 || (_t2 = _`
  width: ${0}%;
  background-color: ${0};
  height: 100%;
`), ({
  progress
}) => progress, palette('primary'));
const ProgressBar = ({
  progress: _progress = 0
}) => jsx(MainBar, {
  children: jsx(DynamicBar, {
    "data-testid": "progress-bar",
    progress: _progress
  })
});

export { ProgressBar };
